import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import save from './save';
import './style.css';

registerBlockType('custom/slide', {
    title: 'Slide',
    icon: 'format-image',
    category: 'media',
    parent: ['custom/slideshow-block'],
    attributes: {
        imageUrl: {
            type: 'string',
            default: '',
        },
        backgroundColor: {
            type: 'string',
            default: '',
        },
        position: {
            type: 'string',
            default: 'left',
        },
        imagePosition: {
            type: 'string',
            default: 'image-right',
        },
    },
    edit: Edit,
    save,
});
